/** One random, non-PII key per logical admin edit/delete action. */
export function createAdminEditIdempotencyKey(): string {
  if (typeof globalThis.crypto?.randomUUID !== 'function') {
    throw new Error('Secure idempotency key generation is unavailable.');
  }
  return `dashboard:${globalThis.crypto.randomUUID()}`;
}
